import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, Form, Row, Col } from 'react-bootstrap-5';
import classNames from 'classnames';

import { bookmarkProperty } from 'helpers/clarity_api';
import ProductFeature from '../product_feature';
import {
  setOffMarketHoverPropertyId, setOffMarketPropertyId
} from '../../store/actions/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark, faRectangleHistoryCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { faBookmark as faBookmarkRegular } from '@fortawesome/pro-regular-svg-icons';

import AddToList from '../../../pn_support/add_to_list';
import OffMarketPropertyImage from './off_market_property_image';

function OffMarketResultCard({
  isSelected,
  offMarketHoverPropertyId,
  result,
  setOffMarketHoverPropertyId,
  setOffMarketPropertyId,
  onSelectToggle
}) {
  const isHovering = result.propertyId == offMarketHoverPropertyId;
  const [favorited, setFavorited] = useState(!!result.favorited);

  const onMouseEnter = () => {
    setOffMarketHoverPropertyId(result.propertyId);
  };

  const onMouseLeave = () => {
    setOffMarketHoverPropertyId();
  };

  const onClick = () => {
    onMouseLeave();
    setOffMarketPropertyId(result.propertyId);
  };

  const handleSelectToggle = (e) => {
    e.stopPropagation();
    onSelectToggle(result.propertyId);
  };

  const makeFavorite = (e, value) => {
    e.stopPropagation();

    bookmarkProperty(result.propertyId, value).then(() => setFavorited(value));
  };

  return (
    <Card
      className={classNames('mb-3 overflow-hidden', { shadow: isHovering, 'border-primary': isHovering })}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Row className="g-0 align-items-stretch">
        <Col>
          <Card.Body className="h-100 d-flex gap-3">
            <ProductFeature product="prospecting">
              <Form.Check
                checked={isSelected}
                id={`property_${result.propertyId}_checkbox`}
                type="checkbox"
                onChange={handleSelectToggle}
              />
            </ProductFeature>

            <div
              className="d-flex flex-column justify-content-md-between gap-3 gap-md-0 clickable clickable-text flex-grow-1"
              onClick={onClick}
            >
              <div>
                <div className="mb-0 result-address fw-bold">{result.address}</div>
                <div className="text-muted">
                  <small>{result.city}, {result.state} {result.zip}</small>
                </div>
              </div>
              <div className="text-muted">
                {result.highlights.map((highlight, i) => (
                  <React.Fragment key={i}>
                    <small> {highlight.value} {highlight.label} </small>
                    {i < result.highlights.length - 1 && <span className="mx-1">•</span>}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </Card.Body>
        </Col>
        <Col
          className="position-relative w-xs-100 text-center map-result-thumb off-market-result-thumb d-none d-md-block"
          md={{ order: 'last', span: 'auto' }}
          xs={{ order: 'first', span: '12' }}
        >
          <OffMarketPropertyImage result={result} />
          <ProductFeature product="prospecting">
            <div
              className={classNames(
                'position-absolute top-0 end-0',
                'd-flex align-items-center gap-3',
                'px-2 py-1 m-2',
                'bg-white rounded'
              )}
            >
              <div
                className="text-primary clickable"
                onClick={e => makeFavorite(e, !favorited)}
              >
                <FontAwesomeIcon icon={favorited ? faBookmark : faBookmarkRegular} />
              </div>

              <AddToList
                itemCount={1}
                itemIds={new Set([result.propertyId])}
              >
                <FontAwesomeIcon className="text-primary clickable" icon={faRectangleHistoryCirclePlus}/>
              </AddToList>
            </div>
          </ProductFeature>
        </Col>
      </Row>
    </Card>
  );
}

OffMarketResultCard.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  offMarketHoverPropertyId: PropTypes.number,
  result: PropTypes.shape({
    address: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
  }).isRequired,
  setOffMarketHoverPropertyId: PropTypes.func.isRequired,
  setOffMarketPropertyId: PropTypes.func.isRequired,
  onSelectToggle: PropTypes.func.isRequired
};

const mapStateToProps = ({ ui: { offMarketHoverPropertyId } }) => ({ offMarketHoverPropertyId });
export default connect(
  mapStateToProps,
  { setOffMarketHoverPropertyId, setOffMarketPropertyId }
)(OffMarketResultCard);
